// extracted by mini-css-extract-plugin
export default {"templates":"Templates_templates__21wrJ"};